export default __webpack_public_path__ + "static/Maison-Bold-36f9c3d136fa319c53bfabf3c5f0b9d5.woff2";